import React, { HTMLAttributes } from "react";
import "./grid-table-body.css";

export interface GridTableBodyUIProps {}

export type GridTableBodyProps = HTMLAttributes<HTMLDivElement> & GridTableBodyUIProps;

/**
 * Table body container
 */
export default function GridTableBody({
  className,
  children,
  ...rest
}: GridTableBodyProps) {
  const classes = ["grid-table-body", className].filter(Boolean).join(" ");
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
